'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './bulletin-public.routes';

export class BulletinPublicComponent {
  constructor(BulletinService, Config, $state) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    const bulletinConfig = Config.getModuleConfig(Config.Modules.Bulletin);

    this.navStyle = bulletinConfig.getNavStyle();
    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Bulletin Board");

    this.categories = bulletinConfig.getCategories();
    this.dataPerCategory = {};

    this.BulletinService = BulletinService;

    BulletinService.queryPublic(data => {
      this.data = data;

      this.categories.forEach(cat => {
        this.dataPerCategory[cat] = this.data.filter(post => {
          return post.categories.indexOf(cat) !== -1;
        });
      });

    }, err => {
      console.log('Could not retrieve public bulletin board posts from server');
    });
  }

}

export default angular.module('conduuApp.bulletinPublic', [uiRouter])
  .config(routes)
  .component('bulletinPublic', {
    template: require('./bulletin-public.html'),
    controller: BulletinPublicComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/bulletin/list/public/bulletin-public.component.js